/**
 * Created by XUQIANG on 2016/4/5.
 */
import moment from 'moment';
import { CHINESE, ENGLISH } from './constants.js';
//获取URL地址的参数值。
//name为URL参数名
//例如：?param1=abc&param2=123
//当调用GetURLparam("param2"）时，获取到的值为：123
export const getUrlParam = name => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  const r = decodeURIComponent(window.location.search)
    .substr(1)
    .match(reg);
  if (r != null) return r[2];
  return null;
};

/**
 *格式化DateTime
 */
export const formatTimeStampToDate = (timeStamp, format, locale) => {
  if (format == null || format == '') {
    format = 'YYYY-MM-DD HH:mm';
  }
  if (timeStamp == null) {
    return '';
  }
  let time = moment(parseInt(timeStamp)).format(format);
  if (locale) {
    switch (locale) {
      case CHINESE:
        time = time.replace('am', '上午');
        time = time.replace('pm', '下午');
        break;
      case ENGLISH:
        time = time.replace('pm', 'PM');
        time = time.replace('am', 'AM');
        break;
    }
  }
  return time;
};

//将时间戳转化为时间
export const timeStampToDate = timeStamp => {
  if (!timeStamp) {
    return null;
  }
  const date = moment(parseInt(timeStamp)).toDate();
  return date;
};

//获取时间列表例如00：00， 10：30;
//interval时间间隔 （分钟）
//from开始时间,end结束时间(分钟)
export const getTimeLists = (interval, from = 0, end = 1440) => {
  let res = [];
  for (let i = from; i < end; i = i + interval) {
    //先转化为小时
    const hour = parseInt(i / 60);
    let hours = '';
    if (hour < 10) {
      hours = '0' + hour;
    } else {
      hours = hour.toString();
    }
    //转化为分钟
    const second = parseInt(i % 60);
    let seconds = '';
    if (second < 10) {
      seconds = '0' + second;
    } else {
      seconds = second.toString();
    }
    res.push(hours + ':' + seconds);
  }
  return res;
};

//获取某个日期的0点的时间戳
export const getDayToZeroTimes = value => {
  return (
    value.getTime() -
    value.getHours() * 3600000 -
    value.getMinutes() * 60000 -
    value.getSeconds() * 1000 -
    value.getMilliseconds()
  );
};

//将00:30转化为分钟
export const strToSecond = time => {
  if (!time) {
    return;
  }
  if (time.indexOf(':') == -1) {
    return Math.round(time);
  }
  return Math.round(
    Number(time.split(':')[0]) * 60 + Number(time.split(':')[1])
  );
};

//将分钟转化为 00:30
export const secondToStr = second => {
  if (second < 60) {
    if (second == 0) {
      return '00:00';
    }
    return `00:${second}`;
  }
  return `${
    Math.floor(second / 60) < 10
      ? '0' + Math.floor(second / 60)
      : Math.floor(second / 60)
  }:${second % 60 < 10 ? '0' + (second % 60) : second % 60}`;
};

export const isEdge = () => {
  var explorer = window.navigator.userAgent;
  return explorer.indexOf('Edge') >= 0;
};

export const isIE = () => {
  var explorer = window.navigator.userAgent;
  return explorer.indexOf('MSIE') >= 0 || explorer.indexOf('Trident/7.0') >= 0;
};

export const initTime = value => {
  if (value === undefined) {
    return null;
  } else {
    const tem = Math.ceil(moment(value).minute() / 15) * 15;
    return moment(value).minute(tem);
  }
};

/**
 * 用于判断访问客户端为手机/pc浏览器
 */
export const isPC = () => {
  const userAgentInfo = navigator.userAgent;
  const Agents = [
    'Android',
    'iPhone',
    'SymbianOS',
    'Windows Phone',
    'iPad',
    'iPod'
  ];
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
};

/**
 * 将对象中的属性解析为&符号拼接的url信息，不带第一个?
 */
export const parsePropertyToUrl = obj => {
  const arr = [];
  for (let property in obj) {
    let value = obj[property];
    if (typeof value === 'number') {
      value = String(value);
    }
    arr.push(`${property}=${value ? value : ''}`);
  }
  return arr.join('&');
};



// WEBPACK FOOTER //
// ./src/utils/common.js